import React, { useState } from 'react';

import CardLayout from '@magoosh/layouts/card';
import { InfoAlert } from '@magoosh/lib/alerts';

import ContentCard from '../../components/content_card';
import SectionHeader from '../../components/section_header';
import SuggestedEdits from '../../components/suggested_edits';
import SuggestedEditFilters from '../../components/suggested_edits/filters';

import { EditedResponseFilter, EssayScoreReport } from '../../../types';

interface Props {
  examName: string;
  scoreReport: EssayScoreReport;
}

export default (props: Props) => {
  const [suggestedEditFilters, setSuggestedEditFilters] = useState<EditedResponseFilter[]>([]);

  return (
    <CardLayout.Card className="d-flex flex-column flex-md-row gap-m gap-lg-xl">
      <SectionHeader
        subtitle={
          <div className="d-flex flex-column gap-m">
            <div className="small">
              This experimental feature uses AI to offer ideas for how to improve your score by about 1 point. You may review the rationale for each edit by selecting filters.
            </div>

            {
              props.scoreReport.content?.editedResponse && (
                <SuggestedEditFilters
                  activeFilters={suggestedEditFilters}
                  filters={props.scoreReport.content.editedResponse?.filters || []}
                  onChange={(filters) => setSuggestedEditFilters(filters)}
                />
              )
            }
          </div>
        }
        supertitle="Suggested edits"
        supertitleIcon="pencil-square"
        title="How to improve your score"
      />

      <div className="d-flex flex-1 flex-column gap-m" style={{ minWidth: 0 }}>
        {
          props.scoreReport.content?.editedResponse && (
            <InfoAlert>
              We've made edits to offer ideas for how to improve your score by about 1 point.
            </InfoAlert>
          )
        }

        <ContentCard className="d-flex flex-1 flex-column gap-m">
          <SuggestedEdits
            activeFilters={suggestedEditFilters}
            editedResponse={props.scoreReport.content?.editedResponse}
            examName={props.examName}
            filters={props.scoreReport.content?.editedResponse?.filters || []}
            gradedAt={props.scoreReport.finishedAt}
            onChangeFilters={setSuggestedEditFilters}
            score={props.scoreReport.score}
            status={props.scoreReport.status}
          />
        </ContentCard>
      </div>
    </CardLayout.Card>
  );
};
